import Area from '@/components/Area';
import { Html, OrbitControls, Preload, useTexture } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import * as React from 'react';
import * as THREE from 'three';
import imgOutSide from './2294472375_24a3b8ef46_o.jpg.chunk';
import imgInside from './Photosphere1.jpg.chunk';
import { Popover, Text, Button, MantineProvider } from '@mantine/core';

type StoreItem = {
  name: string;
  color: string;
  position: [number, number, number];
  url: string;
  link: number;
};

const store: StoreItem[] = [
  { name: 'outside', color: 'lightpink', position: [10, 0, -15], url: imgOutSide, link: 1 },
  { name: 'inside', color: 'lightblue', position: [15, 0, 0], url: imgInside, link: 0 },
  // ...
];

type DomeProps = {
  name: string;
  position: [number, number, number];
  texture: THREE.Texture;
  onClick: () => void;
};

function Dome({ name, position, texture, onClick }: DomeProps) {
  return (
    <group>
      <mesh>
        <sphereGeometry args={[500, 60, 40]} />
        <meshBasicMaterial map={texture} side={THREE.BackSide} />
      </mesh>
      <mesh position={position}>
        <sphereGeometry args={[1.25, 32, 32]} />
        <meshBasicMaterial color="white" />
        <Html center>
          <MantineProvider>
            <Popover width={200} position="bottom">
              <Popover.Target>
                <Button>{name}</Button>
              </Popover.Target>
              <Popover.Dropdown>
                <Text size="sm" color="dimmed">
                  {name} - Click to switch
                </Text>
                <Button variant="light" color="blue" fullWidth mt="xs" onClick={onClick}>
                  Switch to {name === 'outside' ? 'inside' : 'outside'}
                </Button>
              </Popover.Dropdown>
            </Popover>
          </MantineProvider>
        </Html>
      </mesh>
    </group>
  );
}

function Portals() {
  const [which, setWhich] = React.useState(0);
  const { link, ...props } = store[which];
  const maps = useTexture(store.map((s) => s.url));
  return <Dome onClick={() => setWhich(link)} {...props} texture={maps[which]} />;
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas frameloop="demand" camera={{ position: [0, 0, 0.1] }}>
          <OrbitControls
            enableZoom={false}
            enablePan={false}
            // enableDamping
            // dampingFactor={0.2}
            // autoRotate={false}
            // rotateSpeed={-0.5}
          />
          <React.Suspense>
            <Preload all />
            <Portals />
          </React.Suspense>
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
